module.exports = __webpack_public_path__ + "static/media/BizTechFrame5.92ec1ccf.png";